"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Services = function (_Component) {
  (0, _inherits3.default)(Services, _Component);

  function Services() {
    (0, _classCallCheck3.default)(this, Services);
    return (0, _possibleConstructorReturn3.default)(this, (Services.__proto__ || (0, _getPrototypeOf2.default)(Services)).apply(this, arguments));
  }

  (0, _createClass3.default)(Services, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Lis\xE4palvelut" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h3" },
              "Lis\xE4palvelut"
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Lupapalvelut ja toimintasuunnitelmat"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Suunnitteletteko liiketoimintanne laajentamista? Edellytt\xE4\xE4k\xF6 toimintanne kehitt\xE4minen voimassa olevien ymp\xE4rist\xF6lupien laajentamista tai tarvitsetteko mahdollisesti kokonaan uuden luvan? Sitowisen vastuullisuuspalvelut tarjoaa kattavat lupapalvelut projektin kaikkiin vaiheisiin."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Luvitustarpeiden alkukartoituksessa k\xE4ymme l\xE4pi lupienne nykytilanteen ja mahdolliset muutosten tarpeet. Tarvittaessa teemme karkean ymp\xE4rist\xF6olosuhteiden kartoituksen ja k\xE4ymme alustavat keskustelut paikallisten viranomaisten kanssa tulevista lupa- ja selvitystarpeista varsinaista lupaa varten."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Nykytila-analyysin perusteella voimme tarjota erikseen lupahakemusten laadintaa. Mit\xE4 selke\xE4mpi suunnitelma on haettavasta toiminnasta ennen hakemuksen laadintaa, sit\xE4 jouhevammin hakemus saadaan laadittua. L\xE4ht\xF6tietojen laadukas kokoaminen onkin hyv\xE4 huomioida, sill\xE4 lupaprosessit ovat aikaa vievi\xE4 ja saattavat puutteellisesti valmisteltuina tarpeettomasti hidastaa uuden toiminnan aloittamista."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Ker\xE4ttyjen l\xE4ht\xF6tietojen avulla voimme my\xF6s auttaa teit\xE4 laatimaan toimintasuunnitelman tulevan tavoitetilan saavuttamiseksi. Asiantuntijoidemme avulla saatte suunnitelman parhaasta etenemistavasta kehitysty\xF6n edist\xE4miseksi. Suunnitelmassa k\xE4yd\xE4\xE4n l\xE4pi kehitysty\xF6n vaiheet, vaatimukset, edellytykset sek\xE4 aikataulutus ja muut ty\xF6n kannalta oleelliset tekij\xE4t."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Vastaanottolipukekaupan tehostaminen"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Maap\xF6rssin ylij\xE4\xE4m\xE4maa-ainesten vastaanottosovellus on tehokas tapa myyd\xE4 vastaanottolipukkeita pidempiaikaisille ty\xF6maille. Perim\xE4ll\xE4 maksua puhtaiden maa-ainesten vastaanotosta saatte tarvitsemienne maa-ainesten lis\xE4ksi tervetullutta tulorahoitusta projekteillenne."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Lipukekauppanne n\xE4kyvyyden parantamiseksi tarjoamme teille Maap\xF6rssin r\xE4\xE4t\xE4l\xF6ityj\xE4 uutiskirjeit\xE4. Valitsemalla uutiskirjepalvelumme varmistutte siit\xE4, ett\xE4 nykyisill\xE4 ja uusilla yhteisty\xF6kumppaneillanne on ajantasainen tieto vastaanottopaikkanne kapasiteetista silloin, kun itse niin haluatte. Asiakkaanamme p\xE4\xE4sette vaikuttamaan uutiskirjeen sis\xE4lt\xF6\xF6n ja tied\xE4tte, ett\xE4 markkinoinnin ja tiedottamisen kohderyhm\xE4 on juuri oikea. Uutiskirjeen julkaisu on mahdollista toteuttaa kertaluontoisena tai sen voidaan sopia toistuvan useamman kerran haluamanne aikav\xE4lin puitteissa."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Lis\xE4tietoja palveluistamme",
              " ",
              _react2.default.createElement(
                "a",
                { href: "mailto:asiakaspalvelu@maaporssi.fi" },
                "asiakaspalvelu@maaporssi.fi"
              ),
              ", puh. ",
              _react2.default.createElement(
                "a",
                { href: "tel:+358444279803" },
                "044 427 9803"
              )
            )
          )
        )
      );
    }
  }]);
  return Services;
}(_react.Component);

exports.default = Services;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Services/Services.js
 ** module id = 1244
 ** module chunks = 0
 **/